import { useContext, useEffect, useState } from "react";
import AppContext from "../../../AppContext";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import { toast } from "react-toastify";
import { Col, Modal, Row } from "react-bootstrap";
import { GroupButton } from "../../components/GroupButton";
import TableTimesheetsSynthetic from "./TableTimesheetsSynthetic";
import moment from "moment";
import { FORMAT_DATE } from "../../constants/moduleConsts";

const DialogPrintTimekeepingSynthetic = (props: any) => {
    const {
        open,
        dateSearch = {},
        data = [],
        handleClose = () => { }
    } = props;
    const { setPageLoading } = useContext(AppContext);
    const { lang } = useMultiLanguage();

    const handlePrint = () => {
        let style = `
          @media print {
            body { zoom: 0.7; margin: 20px 50px }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid black; text-align: center; }
            
            table td.isWeekendPrint, table th.isWeekendPrint {
                background-color: #ffd6b4 !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact; /* Firefox */
            }
            
            .container-title {
                position: relative;
                padding-top: 1.25rem;
                margin-bottom: 1.25rem;
            }
    
            .title-table-print {
                font-weight: bold;
                text-transform: uppercase;
                font-size: 1.75rem;
                text-align: center;
                margin: 0px;
            }
    
            .title-time-print {
                font-weight: bold;
                font-size: 1.25rem;
                text-align: center;
                margin: 0px;
            }

            .container-header {
                display: flex;
                justify-content: space-between;
                margin-left: 1.25rem;
                margin-top: 3rem;
            }

            .title-header {
                font-weight: bold;
                font-size: 1.35rem;
                text-align: center;
                margin: 0px;
            }

            .text-left {
                text-align: left !important;
            }
            
            .container-footer {
                margin-top: 30px;
                margin-bottom: 100px;
            }

            .time-footer {
                text-align: end;
                font-style: italic;
                margin-bottom: 10px;
            }

            .footer {
                display: flex;
                justify-content: space-between;
            }
            
            .title-footer {
                text-align: center;
                font-weight: bold;
                margin: 0;
            }

            .span-footer {
                text-align: center;
                font-style: italic;
                margin: 0;
            }

            .text-uppercase {
                text-transform: uppercase;
            }

            @page {
                margin: 20px !important; 
            }
          }
        `;
        const content = document.getElementById("content-print");
        if (content) {
            const printWindow = window.open('', '_blank', 'width=800,height=600');
            if (printWindow) {
                printWindow.document.open();
                printWindow.document.write(`
              <html>
                <head>
                  <title>Bang_Thong_Ke_Nhan_Su</title>
                  <style>${style}</style>
                </head>
                <body onload="window.print(); window.close();">
                  ${content.innerHTML}
                </body>
              </html>
            `);
                printWindow.document.close();
            }
        }
    }

    if (!open) return <></>

    return (
        <Modal
            show={open}
            onHide={() => {
                handleClose();
            }}
            backdrop="static"
            size="xl"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {lang("PRINT_TIMEKEEPING_TABLE")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="spaces py-0">
                <iframe
                    id="ifmcontentstoprint"
                    style={{
                        height: "0px",
                        width: "0px",
                        position: "absolute",
                    }}
                ></iframe>
                <div className="time-sheets-print">
                    <Row id="content-print" className="px-4">
                        <div className="container-header ms-5 mt-5">
                            <div>
                                <p className="fw-bold text-uppercase fs-3 text-center m-0 title-header">
                                    {(data[0] as any)?.orgName || ""}
                                </p>
                            </div>
                            <div>
                                <p className="fw-bold text-center m-0 title-header">Mẫu số C01a - HD</p>
                                <p className="fw-bold text-center m-0 title-header">(Ban hành theo thông tư số: 107/2017/TT-BTC</p>
                                <p className="fw-bold text-center m-0 title-header">ngày 10/10/2017 của Bộ Tài chính)</p>
                            </div>
                        </div>

                        <Col xs={12}>
                            <div className="container-title relative pt-5 mb-3">
                                <p className='fw-bold text-uppercase fs-1 text-center m-0 title-table-print'>{lang("TIMESHEET.LIST.SYNTHETIC")}</p>
                                <p className="fw-bold fs-4 text-center m-0  title-time-print">
                                    {moment(dateSearch.fromDate).isSame(dateSearch.toDate, 'day') ?
                                        `Ngày ${moment(dateSearch.fromDate).format("DD")} tháng ${moment(dateSearch.fromDate).format("MM")} năm ${moment(dateSearch.fromDate).format("YYYY")}`
                                        :
                                        `Từ ngày ${moment(dateSearch.fromDate).format(FORMAT_DATE.DD_MM_YYYY)} đến ngày ${moment(dateSearch.toDate).format(FORMAT_DATE.DD_MM_YYYY)}`
                                    }
                                </p>
                            </div>
                            <TableTimesheetsSynthetic
                                data={data}
                                pageable={[]}
                                searchObject={dateSearch}
                                setSearchObject={() => { }}
                                noPagination={true}
                            />
                        </Col>
                        <div className="container-footer">
                            <div className="time-footer">......, Ngày ..... tháng ..... năm ....</div>
                            <div className="footer">
                                <div>
                                    <p className="title-footer">Người chấm công</p>
                                    <p className="span-footer">(Ký, Họ tên)</p>
                                </div>
                                <div>
                                    <p className="title-footer">Phụ trách khoa, phòng</p>
                                    <p className="span-footer">(Ký, Họ tên)</p>
                                </div>
                                <div>
                                    <p className="title-footer">Người duyệt</p>
                                    <p className="span-footer">(Ký, Họ tên)</p>
                                </div>
                            </div>
                        </div>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <GroupButton
                    handleEvent={() => {
                        handlePrint();
                    }}
                >
                    {lang("BTN.PRINT")}
                </GroupButton>
                <GroupButton
                    type="btn-cancel"
                    handleCloseUpdateDialog={() => {
                        handleClose();
                    }}
                />
            </Modal.Footer>
        </Modal>
    )
};

export default DialogPrintTimekeepingSynthetic;